// Events
import { ACTION_DIALOG_CLOSE, THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

// Utils
import { getCart } from 'utils/cart';
import { getProduct } from 'utils/product';
import { dispatch } from 'utils/theme';

export default component(async (node, ctx) => {
  document.addEventListener('theme:variant:selected', ({ detail }) => {
    const button = node.querySelector(`[data-product-button="${detail.handle}"]`);
    const select = node.querySelector(`[data-select="${detail.handle}"]`);

    button.textContent = detail.title;

    if (select) {
      select.value = detail.id;
    }
  });

  document.addEventListener('theme:product:swap', ({ detail }) => {
    const items = node.querySelectorAll(
      `[data-look="${detail.product}"], [data-look="${detail.relation}"]`,
    );
    const currentItem = node.querySelector(`[data-look="${detail.handle}"]`);

    ctx.emit(ACTION_DIALOG_CLOSE);

    const event = new CustomEvent('action:dialog:open', {
      detail: `product-${detail.handle}-variant-selector`,
    });
    document.dispatchEvent(event);

    items.forEach((item) => {
      item.hidden = true;
    });

    currentItem.hidden = false;
  });

  node.addEventListener('submit', async (event) => {
    event.preventDefault();

    const selects = node.querySelectorAll('[data-select]');
    const data = new FormData();
    const items = [];

    selects.forEach((select) => {
      if (select.parentElement.offsetParent === null || !select.value) {
        return;
      }
      items.push({ handle: select.dataset.select, variantId: select.value });
      data.append(select.name, select.value);
    });

    await fetch(`${node.action}.js`, {
      method: node.method,
      body: data,
    });

    try {
      const products = await Promise.all(items.map(({ handle }) => getProduct(handle)));

      dispatch('look-add-to-cart', {
        items: products.map((product, index) => ({
          product,
          variant: product.variants.find(
            (variant) => variant.id === Number(items[index].variantId),
          ),
          quantity: 1,
        })),
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    await getCart().then((response) => {
      ctx.emit(THEME_CART_UPDATED, { cart: response });
    });
  });
});
